import React, { Component } from "react";
import { Button, Loader, Modal } from "semantic-ui-react";
import { Document, Page } from "react-pdf";

import { isImage } from "./ItemUploader";

class DocumentPreview extends Component {
  state = {
    error: null,
    loading: true,
    numPages: null,
    pageNumber: 1,
    pdf: null,
  };

  componentDidMount = () => {
    if (!isImage(this.props.src)) {
      this.setState({ pdf: this.props.src });
    }
  };

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  };

  onNextPage = (e) => {
    e.preventDefault();
    const { pageNumber, numPages } = this.state;

    if (pageNumber < numPages) {
      this.setState({ pageNumber: pageNumber + 1 });
    }
  };

  onPreviousPage = (e) => {
    e.preventDefault();
    const { pageNumber } = this.state;

    if (pageNumber > 1) {
      this.setState({ pageNumber: pageNumber - 1 });
    }
  };

  toggleOpen = () => this.setState({ open: !this.state.open });

  render() {
    const { numPages, pageNumber, pdf, open } = this.state;

    return (
      <Modal open onClose={this.props.onClose} size="large">
        <Modal.Header content={this.props.title} />
        <Modal.Content style={{ minHeight: "300px" }}>
          {pdf && (
            <div style={{ minHeight: "100px" }}>
              <Document
                loading={<Loader active />}
                file={this.props.src}
                onLoadSuccess={this.onDocumentLoadSuccess}
                renderMode="svg"
              >
                <Page
                  scale={window.innerWidth <= 1024 ? 1.05 : 1.5}
                  pageNumber={pageNumber}
                />
              </Document>
              <Button
                content="Previous"
                onClick={this.onPreviousPage}
                disabled={pageNumber === 1 ? true : false}
              />
              <Button
                content="Next"
                onClick={this.onNextPage}
                disabled={pageNumber === numPages ? true : false}
              />
            </div>
          )}
          {isImage(this.props.src) && (
            <img
              src={this.props.src}
              style={{
                display: "block",
                margin: "0 auto",
                maxWidth: "100%",
                maxHeight: "500px",
                objectFit: "contain",
              }}
            />
          )}
        </Modal.Content>
      </Modal>
    );
  }
}

export default DocumentPreview;
